module.exports = __webpack_public_path__ + "img/logo.8ea557a1.png";